import Vue from 'vue'
import VueWorldMap from 'vue-world-map'

Vue.component('VWorldMap', VueWorldMap)
